"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var styles = {
  title: {
    fontSize: '16px',
    lineHeight: '50px',
    height: '50px',
    color: _userflow["default"].colors.black
  },
  description: {
    fontSize: '14px',
    lineHeight: '18px',
    color: _userflow["default"].colors.blackBase
  }
};
var Column = function Column(_ref) {
  var title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.title
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.description
  }, description));
};
var _default = exports["default"] = Column;